import { withDevToolsStub } from "@angular-architects/ngrx-toolkit";

import { version } from "../../package.json";
import { LANGUAGES } from "../app/api/local-144/models/languages-array";
import type { Environment } from "./types/environment.interface";

export const environment: Environment = {
    apiUrl: "https://api.local144.recursyve.dev",
    availableLanguages: LANGUAGES,
    defaultLanguage: "fr",
    firebase: {
        apiKey: "AIzaSyBNMx76wQCFEU-pY3RF1K_tsW555rTT2Ig",
        authDomain: "local144-dev.firebaseapp.com",
        projectId: "local144-dev",
        storageBucket: "local144-dev.appspot.com",
        messagingSenderId: "723982693136",
        appId: "1:723982693136:web:e77d6f2fe2579941f12b95"
    },
    sentry: {
        dsn: "https://790d95c0615b4922b29f72786d473d9a@o341312.ingest.sentry.io/4504085122711552",
        environment: "staging",
        enableLogs: true,
        enabled: true,
        replaysOnErrorSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        tracePropagationTargets: ["https://api.local144.recursyve.dev"],
        tracesSampleRate: 1.0
    },
    version,
    withDevtools: withDevToolsStub
};
